import './index.scss';
import { isNullOrUndef } from '../../utils/isNullOrUndef';
const doc = document;
const win = window;
(() => {
    const btn = doc.querySelector('.show_more_blog__category__title');
    const items = doc.querySelectorAll('.categories-content');
    if (isNullOrUndef(btn) || items.length < 4)
        return;
    let expanded = false;
    btn.addEventListener('click', () => {
        expanded = !expanded;
        for (let i = 4; i < items.length; i++) {
            items[i].hidden = !expanded;
        }
        btn.setAttribute('aria-expanded', String(expanded));
    });
})();
(function () {
    doc.querySelector('.insp__share-button_copy')?.addEventListener('click', () => {
        void navigator.clipboard.writeText(window.location.href);
    });
}());
